"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.abi = void 0;
const erc20_json_1 = __importDefault(require("./token/erc20.json"));
const erc721_json_1 = __importDefault(require("./token/erc721.json"));
const RelayAdapt_json_1 = __importDefault(require("./adapt/RelayAdapt.json"));
const UniV2LikeFactory_json_1 = __importDefault(require("./liquidity/UniV2LikeFactory.json"));
const UniV2LikeRouter_json_1 = __importDefault(require("./liquidity/UniV2LikeRouter.json"));
const UniV2LikePair_json_1 = __importDefault(require("./liquidity/UniV2LikePair.json"));
const BeefyVault_MergedV6V7_json_1 = __importDefault(require("./vault/beefy/BeefyVault-MergedV6V7.json"));
const RewardRouterV2_json_1 = __importDefault(require("./vault/gmx/RewardRouterV2.json"));
const GlpManager_json_1 = __importDefault(require("./vault/gmx/GlpManager.json"));
const Vault_json_1 = __importDefault(require("./vault/gmx/Vault.json"));
const AccessCardERC721_json_1 = __importDefault(require("./access-card/AccessCardERC721.json"));
const AccessCardOwnerAccount_json_1 = __importDefault(require("./access-card/AccessCardOwnerAccount.json"));
const AccessCardAccountCreator_json_1 = __importDefault(require("./access-card/AccessCardAccountCreator.json"));
exports.abi = {
    token: {
        erc20: erc20_json_1.default,
        erc721: erc721_json_1.default,
        accessCardERC721: AccessCardERC721_json_1.default,
    },
    accessCard: {
        erc721: AccessCardERC721_json_1.default,
        ownerAccount: AccessCardOwnerAccount_json_1.default,
        accountCreator: AccessCardAccountCreator_json_1.default,
    },
    adapt: {
        relay: RelayAdapt_json_1.default,
    },
    liquidity: {
        uniV2LikeFactory: UniV2LikeFactory_json_1.default,
        uniV2LikeRouter: UniV2LikeRouter_json_1.default,
        uniV2LikePair: UniV2LikePair_json_1.default,
    },
    vault: {
        beefy: BeefyVault_MergedV6V7_json_1.default,
        gmx: {
            rewardRouterV2: RewardRouterV2_json_1.default,
            glpManager: GlpManager_json_1.default,
            vault: Vault_json_1.default,
        },
    },
};
